import { RecordingType } from '@ftr/contracts/type/recording'
import { Uuid } from '@ftr/contracts/type/shared'
import { getRecordingPath as getRecordingPathFromRoutingPaths } from '@ftr/routing-paths'

export function getRecordingPath(
  courtSystemId: Uuid,
  recordingId: Uuid,
  recordingType: RecordingType = RecordingType.TRM,
  relative = false,
): string[] {
  return getRecordingPathFromRoutingPaths(courtSystemId, recordingId, recordingType, relative)
}
